// extracted by mini-css-extract-plugin
export default {"pageWrap":"Ub-z","fullWidth":"Vb-z","heading":"Wb-z","fullBleed":"Xb-z","hidden":"Yb-z"};